import orderInstance from '../../instance'

const getBusinessScopeDiscount = (businessScope) => {
  return orderInstance.get(`/discounts/businessScopes/${businessScope}`)
}

export default getBusinessScopeDiscount
